import React, {Component} from 'react';
import './creativeHeader.css';
import logo from '../../assets/header/CL_Logo_White+Lemon_Horizontal.png';
import CampaignModal from '../Modal/Campaign';
import {Link} from 'react-router-dom';
import AccessControl from '../../utils/AccessControl';
import connect from "react-redux/es/connect/connect";
import SVG from 'react-inlinesvg';
import caretDown from '../../assets/caret-down.svg';
import closeBtn from '../../assets/close.svg';
import stackedLogo from '../../assets/header/CL_Logo_White+Lemon_Stacked.png';
import CampaignModalContainer from "../Modal/campaignModalContainer";
import {getCreativeInfo} from "../../actions/campaignActions";


class CreativeHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: {
                campaign: false
            },
            showMenu: false,
            user: true,
            height: 0, scrolltop: 0,
            setSmall: false,
            small: false
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    toggleModal = (type, show) => {
        if (document.body.style.overflow !== "hidden") {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "scroll";
        }
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };

    toggleMenu() {
        this.updateWindowDimensions();
        if (!this.state.showMenu) {
            this.setState({
                showMenu: true
            })
        } else {
            this.setState({
                showMenu: false
            })
        }
    }

    closeMenu() {
        this.setState({
            showMenu: false
        })
    }

    componentDidMount() {
        this.props.dispatch(getCreativeInfo());
        if (this.props.user.email !== undefined) {
            if (this.props.user.roles[0] === 'editor' || this.props.user.roles[0] === 'admin') {
                // socket.emit('join', {email: this.props.user.email});
            }
        }
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.user.email !== prevProps.user.email) {
            if (this.props.user.roles[0] === 'editor' || this.props.user.roles[0] === 'admin') {

            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        if (this.state.showMenu) {
            this.setState({showMenu: false});
        }
    }

    handleLogout = (e) => {
        e.preventDefault();
        const { user } = this.props;
        const email = (user && user.email) ? user.email : '';
        const domain = email.split('@')[1];

        if (domain === 'cadent.tv') {
            // window.location.href = 'http://localhost:8080/OktaSignOut'; //dev
            window.location.href = 'OktaSignOut';
        } else {
            // window.location.href = 'http://localhost:8080/logout'; //dev
            window.location.href = 'logout';
        }
    }

    render() {
        return (
            <section className="cl-header wrapper">
                <div className="row-1">
                    <Link to="/">
                        <img id="cl-stacked-logo" src={stackedLogo} style={{"maxWidth": "90px"}} alt="Studio AT Creative Library stacked logo" />
                        <img id="cl-logo" src={logo} style={{"maxWidth": "200px"}} alt="Studio AT Creative Library logo" />
                    </Link>
                </div>
                <div className={`row-2 ${this.props.hide ? 'headline-hide' : ''}`} >
                    <div className="mobileMenuIcon" onClick={() => this.toggleMenu()}>
                        <span className="menu-line"></span>
                        <span className="menu-line"></span>
                        <span className="menu-line"></span>
                    </div>
                    <div className={this.state.showMenu ? "menu-overlay" : ""}></div>
                    <div className={this.state.showMenu ? "hiddenMenu openMenu" : "hiddenMenu"}>
                       <div className="cl-header-close-btn" >
                           <img onClick={() => this.toggleMenu()} src={closeBtn} alt=""/>
                       </div>
                        <div className="sidebar-menu">
                            <ul className="dropdown-hidden">
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['admin']}>
                                    <li><Link to="/manage/users" onClick={() => this.closeMenu()}>Manage Users</Link></li>
                                    <li><Link to="/manage/sellers" onClick={() => this.closeMenu()}>Manage Sellers</Link></li>
                                    <li><Link to="/manage/functionality" onClick={() => this.closeMenu()}>Manage Functionality</Link></li>
                                    <li><Link to="/manage/verticals" onClick={() => this.closeMenu()}>Manage Verticals</Link></li>
                                </AccessControl>
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['admin', 'analytics', 'editor']}>
                                    <li><Link to="/export" onClick={() => this.closeMenu()}>Reports</Link></li>
                                </AccessControl>
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['editor', 'admin']}>
                                    <li><Link to="/manage/campaigns" onClick={() => this.closeMenu()}>Empty Campaigns</Link></li>
                                    <li><Link to="/manage/brands" onClick={() => this.closeMenu()}>Empty Brands</Link></li>
                                    <li><Link to="/manage/jira_units" onClick={() => this.closeMenu()}>Unpublished Mock Units</Link></li>
                                    <li><Link to="/manage/my_creatives" onClick={() => this.closeMenu()}>My Creatives</Link></li>
                                </AccessControl>
                                <li>
                                    <a onClick={this.handleLogout}>Logout</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="username">{this.props.user.fullname === null ? '' : this.props.user.fullname}<SVG src={caretDown}/>
                        <ul className="dropdown">
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['admin']}>
                                <li><Link to="/manage/users">Manage Users</Link></li>
                                <li><Link to="/manage/sellers">Manage Sellers</Link></li>
                                <li><Link to="/manage/functionality">Manage Functionality</Link></li>
                                <li><Link to="/manage/verticals" onClick={() => this.closeMenu()}>Manage Verticals</Link></li>
                                </AccessControl>
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['admin', 'analytics', 'editor']}>
                                    <li><Link to="/export">Reports</Link></li>
                            </AccessControl>
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['editor', 'admin']}>
                                <li><Link to="/manage/campaigns">Empty Campaigns</Link></li>
                                <li><Link to="/manage/brands">Empty Brands</Link></li>
                                <li><Link to="/manage/jira_units" onClick={() => this.closeMenu()}>Unpublished Mock Units</Link></li>
                                <li><Link to="/manage/my_creatives" onClick={() => this.closeMenu()}>My Creatives</Link></li>
                            </AccessControl>
                            <li>
                                <a onClick={this.handleLogout}>Logout</a>
                            </li>
                        </ul>
                    </div>
                    {/*<AccessControl*/}
                    {/*    userPermissions={this.props.user.roles}*/}
                    {/*    allowedPermissions={['editor', 'admin']}*/}
                    {/*><span className="separator">|</span>*/}
                    {/*  </AccessControl>*/}
                </div>
                <AccessControl
                    userPermissions={this.props.user.roles}
                    allowedPermissions={['editor', 'admin']}
                >
                    <div className={`create-btn-container desktopDisplay ${this.props.hide ? 'headline-hide' : ''}`} >
                        <button className="button button--grey--addcampaign button--larger" onClick={() => this.toggleModal('campaign', true)}>Add Campaign
                        </button>
                    </div>
                </AccessControl>
                {this.state.showModal.campaign && <CampaignModalContainer
                    toggleModal={this.toggleModal}
                    create={true}
                    fullUserFlow={true}
                    modal={this.state.showModal}
                    campaign={this.props.campaign.campaign}
                    inputOptions={this.props.campaign.meta}
                    user={this.props.user}
                />}
            </section>
        );
    }
}
const mapStateToProps = state => ({
    campaign: state.campaign,
    user: state.user
});
export default connect(mapStateToProps)(CreativeHeader);
